import React from 'react';

const TopSellingItems = ({ data }) => {
    if (!data) return null;

    return (
        <div className="card shadow-sm h-100">
            <div className="card-body">
                <h6 className="card-title mb-3">Top Selling Items</h6>
                {data.by_quantity && data.by_quantity.length > 0 && (
                    <div className="mb-3">
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Top 10 by Quantity</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Item</th>
                                        <th>Category</th>
                                        <th className="text-end">Qty</th>
                                        <th className="text-end">Revenue</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.by_quantity.map((item, i) => (
                                        <tr key={i}>
                                            <td>{item.item_name} {item.item_code ? `(${item.item_code})` : ''}</td>
                                            <td>{item.category_name}</td>
                                            <td className="text-end">{item.quantity} {item.unit}</td>
                                            <td className="text-end">{item.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
                {data.by_revenue && data.by_revenue.length > 0 && (
                    <div>
                        <h6 className="mb-2" style={{ fontSize: '0.85rem' }}>Top 10 by Revenue</h6>
                        <div className="table-responsive">
                            <table className="table table-sm table-bordered mb-0">
                                <thead className="table-light">
                                    <tr>
                                        <th>Item</th>
                                        <th>Category</th>
                                        <th className="text-end">Qty</th>
                                        <th className="text-end">Revenue</th>
                                        <th className="text-end">Avg Price</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {data.by_revenue.map((item, i) => (
                                        <tr key={i}>
                                            <td>{item.item_name} {item.item_code ? `(${item.item_code})` : ''}</td>
                                            <td>{item.category_name}</td>
                                            <td className="text-end">{item.quantity}</td>
                                            <td className="text-end">{item.revenue?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                            <td className="text-end">{item.avg_price?.toLocaleString(undefined, { minimumFractionDigits: 3 })}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </div>
    );
};

export default TopSellingItems;
